/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CoursePermMapParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['can_submit_others_work', codecBoolean],
    ['can_submit_own_work', codecBoolean],
    ['can_edit_others_work', codecBoolean],
    ['can_grade_work', codecBoolean],
    ['can_see_grade_before_open', codecBoolean],
    ['can_see_others_work', codecBoolean],
    ['can_see_assignments', codecBoolean],
    ['can_see_hidden_assignments', codecBoolean],
    ['can_edit_assignment_info', codecBoolean],
    ['can_assign_graders', codecBoolean],
    ['can_edit_cgignore', codecBoolean],
    ['can_upload_bb_zip', codecBoolean],
    ['can_edit_course_roles', codecBoolean],
    ['can_edit_course_users', codecBoolean],
    ['can_create_assignment', codecBoolean],
    ['can_upload_after_deadline', codecBoolean],
    ['can_see_assignee', codecBoolean],
    ['manage_rubrics', codecBoolean],
    ['can_view_own_teacher_files', codecBoolean],
    ['can_see_grade_history', codecBoolean],
    ['can_delete_submission', codecBoolean],
    ['can_update_grader_status', codecBoolean],
    ['can_update_course_notifications', codecBoolean],
    ['can_edit_maximum_grade', codecBoolean],
    ['can_view_plagiarism', codecBoolean],
    ['can_manage_plagiarism', codecBoolean],
    ['can_list_course_users', codecBoolean],
    ['can_edit_own_groups', codecBoolean],
    ['can_edit_others_groups', codecBoolean],
    ['can_edit_groups_after_submission', codecBoolean],
    ['can_view_others_groups', codecBoolean],
    ['can_edit_group_assignment', codecBoolean],
    ['can_edit_group_set', codecBoolean],
    ['can_create_groups', codecBoolean],
    ['can_view_course_snippets', codecBoolean],
    ['can_manage_course_snippets', codecBoolean],
    ['can_view_hidden_fixtures', codecBoolean],
    ['can_run_autotest', codecBoolean],
    ['can_delete_autotest_run', codecBoolean],
    ['can_edit_autotest', codecBoolean],
    ['can_view_hidden_autotest_steps', codecBoolean],
    ['can_view_autotest_before_done', codecBoolean],
    ['can_view_autotest_step_details', codecBoolean],
    ['can_view_autotest_fixture', codecBoolean],
    ['can_view_autotest_output_files_before_done', codecBoolean],
    ['can_delete_assignments', codecBoolean],
    ['can_override_submission_limiting', codecBoolean],
    ['can_see_linter_feedback_before_done', codecBoolean],
    ['can_see_user_feedback_before_done', codecBoolean],
    ['can_view_analytics', codecBoolean],
    ['can_edit_others_comments', codecBoolean],
    ['can_add_own_inline_comments', codecBoolean],
    ['can_view_others_comment_edits', codecBoolean],
    ['can_view_feedback_author', codecBoolean],
    ['can_email_students', codecBoolean],
    ['can_view_inline_feedback_before_approved', codecBoolean],
    ['can_approve_inline_comments', codecBoolean],
    ['can_edit_peer_feedback_settings', codecBoolean],
    ['can_receive_login_links', codecBoolean],
    ['can_see_archived_courses', codecBoolean],
    ['can_archive_courses', codecBoolean],
    ['can_edit_course_info', codecBoolean],
    ['can_upload_after_lock_date', codecBoolean],
    ['can_see_peer_feedback_before_done', codecBoolean],
    ['can_see_anonymized_names', codecBoolean],
    ['can_view_peer_review_autotest_results', codecBoolean],
    ['can_upload_without_group', codecBoolean],
    ['can_submit_others_in_section_work', codecBoolean],
    ['can_edit_others_in_section_work', codecBoolean],
    ['can_see_others_in_section_work', codecBoolean],
    ['can_edit_others_in_section_groups', codecBoolean],
    ['can_view_others_in_section_groups', codecBoolean],
    ['can_edit_others_in_section_comments', codecBoolean],
    ['can_view_others_in_section_comment_edits', codecBoolean],
    ['can_view_course_sections', codecBoolean],
    ['can_edit_course_sections', codecBoolean],
    ['can_manage_new_autotest', codecBoolean],
    ['can_view_new_autotest_test_steps', codecBoolean],
    ['can_view_new_autotest_hidden_step_configuration', codecBoolean],
    ['can_view_new_autotest_hidden_step_results', codecBoolean],
    ['can_view_new_autotest_hidden_step_output', codecBoolean],
    ['can_always_use_all_upload_types', codecBoolean],
    ['can_view_own_course_section_members', codecBoolean],
    ['can_view_all_assignment_timeframes', codecBoolean],
    ['can_create_test_submissions', codecBoolean],
    ['can_view_pearson_context_templates', codecBoolean],
    ['can_edit_pearson_context_templates', codecBoolean],
    ['can_send_assistant_messages_for_others', codecBoolean],
    ['can_send_assistant_messages_for_others_in_section', codecBoolean],
    ['can_send_assistant_messages', codecBoolean],
    ['can_view_assistant_message_author', codecBoolean],
]));
export class CoursePermMap extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CoursePermMapParser.decode(input).map(res => new CoursePermMap(res));
    }
    static unsafeDecode(input) {
        return CoursePermMap.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CoursePermMapParser.encode(data);
    }
    static schema() {
        return CoursePermMapParser.schema();
    }
}
